import React from "react";
import { isEmailValid } from "@norma-bi/utils";

export const useEmailInput = (initialEmail = "") => {
  const [email, setEmail] = React.useState(initialEmail);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  return {
    email,
    handleEmailChange,
    isEmailValid: isEmailValid(email),
  };
};
